import { Component } from '@angular/core';
import { TagModule } from 'primeng/tag';
import { PaTagComponent } from 'src/app/shared/ui-kit/pa-tag/pa-tag.component';

@Component({
  selector: 'app-tag-view',
  standalone: true,
  imports: [PaTagComponent, TagModule],
  templateUrl: './tag-view.component.html',
  styleUrls: ['./tag-view.component.scss'],
})
export class TagViewComponent {} 